import Flota from './Flota';
import { connect } from 'react-redux';
import { fetchCategories, setSearchCarParams } from 'actions';

const mapStateToProps = ({ global }) => ({
  listCategories: global.listCategories,
});

export default connect(mapStateToProps, { fetchCategories, setSearchCarParams })(Flota);
